var external_file_countries = [
  "Andorra (AD)",
  "Emiratos Arabes (AE)",
  "Afghanistan (AF)",
  "Antigua y Barbuda (AG)",
  "Anguilla (AI)",
  "Albania (AL)",
  "Armenia (AM)",
  "Antillas Holandesas (AN)",
  "Angola (AO)",
  "Samoa Americana (AS)",
  "Austria (AT)",
  "Australia (AU)",
  "Azerbaijan (AZ)",
  "Bosnia Herzegovina (BA)",
  "Barbados (BB)",
  "Bangladesh (BD)",
  "Belgium (BE)",
  "Burkina Faso (BF)",
  "Bulgaria (BG)",
  "Bahrain (BH)",
  "Burundi (BI)",
  "Benin (BJ)",
  "Bermuda (BM)",
  "Brunei (BN)",
  "Bolivia (BO)",
  "Brasil (BR)",
  "Bahamas (BS)",
  "Bhutan (BT)",
  "Bouvet Island (BV)",
  "Botswana (BW)",
  "Bielorusia (BY)",
  "Belize (BZ)",
  "Canada (CA)",
  "Cocos Islands (CC)",
  "Congo RD (CD)",
  "Rep. Centroafricana (CF)",
  "Congo Rep (CG)",
  "Suiza (CH)",
  "Costa de Marfil (CI)",
  "Cook Islands (CK)",
  "Chile (CL)",
  "Camerún (CM)",
  "China (CN)",
  "Colombia (CO)",
  "Costa Rica (CR)",
  "Cuba (CU)",
  "Cabo Verde (CV)",
  "Christmas Island (CX)",
  "Chipre (CY)",
  "Republica Checa (CZ)",
  "Alemania (DE)",
  "Djibouti (DJ)",
  "Dinamarca (DK)",
  "Dominica (DM)",
  "Republica Dominicana (DO)",
  "Algeria (DZ)",
  "Ecuador (EC)",
  "Estonia (EE)",
  "Egypt (EG)",
  "Western Sahara (EH)",
  "Eritrea (ER)",
  "España (ES)",
  "Etiopía (ET)",
  "Finlandia (FI)",
  "Fiji Islands (FJ)",
  "Islas Malvinas (FK)",
  "Micronesia (FM)",
  "Faeroe Islands (FO)",
  "Francia (FR)",
  "Gabon (GA)",
  "Inglaterra (GB)",
  "Grenada (GD)",
  "Georgia (GE)",
  "French Guiana (GF)",
  "Ghana (GH)",
  "Gibraltar (GI)",
  "Groenlandia (GL)",
  "Gambia (GM)",
  "Guinea (GN)",
  "Guadeloupe (GP)",
  "Guinea Ecuatorial (GQ)",
  "Grecia (GR)",
  "Guatemala (GT)",
  "Guam (GU)",
  "Guinea Bissau (GW)",
  "Guyana (GY)",
  "Hong Kong (HK)",
  "Honduras (HN)",
  "Croacia (HR)",
  "Haiti (HT)",
  "Hungría (HU)",
  "Indonesia (ID)",
  "Irlanda (IE)",
  "Israel (IL)",
  "India (IN)",
  "Irak (IQ)",
  "Iran (IR)",
  "Islandia (IS)",
  "Italia (IT)",
  "Jamaica (JM)",
  "Jordan (JO)",
  "Japón (JP)",
  "Kenya (KE)",
  "Kyrgyzstan (KG)",
  "Cambodia (KH)",
  "Kiribati (KI)",
  "Comoros (KM)",
  "St. Kitts - Nevis (KN)",
  "Corea del Norte (KP)",
  "Corea del Sur (KR)",
  "Kuwait (KW)",
  "Islas Cayman (KY)",
  "Kazakstan (KZ)",
  "Rep. de Lao (LA)",
  "Líbano (LB)",
  "Saint Lucia (LC)",
  "Liechtenstein (LI)",
  "Sri Lanka (LK)",
  "Liberia (LR)",
  "Lesotho (LS)",
  "Lithuania (LT)",
  "Luxemburgo (LU)",
  "Latvia (LV)",
  "Libia (LY)",
  "Marruecos (MA)",
  "Monaco (MC)",
  "Moldova (MD)",
  "Madagascar (MG)",
  "Marshall Islands (MH)",
  "Macedonia (MK)",
  "Mali (ML)",
  "Myanmar (MM)",
  "Mongolia (MN)",
  "Macau (MO)",
  "Marianna Islands (MP)",
  "Martinique (MQ)",
  "Mauritania (MR)",
  "Montserrat (MS)",
  "Malta (MT)",
  "Mauritius (MU)",
  "Maldives (MV)",
  "Malawi (MW)",
  "México (MX)",
  "Malasia (MY)",
  "Mozambique (MZ)",
  "Namibia (NA)",
  "New Caledonia (NC)",
  "Niger (NE)",
  "Norfolk Island (NF)",
  "Nigeria (NG)",
  "Nicaragua (NI)",
  "Holanda (NL)",
  "Noruega (NO)",
  "Nepal (NP)",
  "Nauru (NR)",
  "Niue (NU)",
  "Nueva Zelanda (NZ)",
  "Omán (OM)",
  "Panamá (PA)",
  "Peru (PE)",
  "French Polynesia (PF)",
  "Papua Nueva Guinea (PG)",
  "Filipinas (PH)",
  "Pakistan (PK)",
  "Polonia (PL)",
  "San Pedro y Miquelón (PM)",
  "Palestina (PS)",
  "Portugal (PT)",
  "Palau (PW)",
  "Paraguay (PY)",
  "Qatar (QA)",
  "Reunion (RE)",
  "Rumania (RO)",
  "Rusia (RU)",
  "Rwanda (RW)",
  "Saudi Arabia (SA)",
  "Solomon Islands (SB)",
  "Seychelles Islands (SC)",
  "Sudan (SD)",
  "Suecia (SE)",
  "Singapur (SG)",
  "Santa Helena (SH)",
  "Slovenia (SI)",
  "Svalbard y Jan Mayen (SJ)",
  "Slovakia (SK)",
  "Sierra Leone (SL)",
  "San Marino (SM)",
  "Senegal (SN)",
  "Somalia (SO)",
  "Suriname (SR)",
  "Santo Tomé (ST)",
  "El Salvador (SV)",
  "Siria (SY)",
  "Swazilandia (SZ)",
  "Turks y Caicos (TC)",
  "Chad (TD)",
  "Togo (TG)",
  "Tailandia (TH)",
  "Tajikistan (TJ)",
  "Turkmenistan (TM)",
  "Tunisia (TN)",
  "Tonga (TO)",
  "East Timor (TP)",
  "Turquía (TR)",
  "Trinidad & Tobago (TT)",
  "Tuvalu (TV)",
  "Taiwan (TW)",
  "Tanzania (TZ)",
  "Ucrania (UA)",
  "Uganda (UG)",
  "Islas de EEUU (UM)",
  "Estados Unidos (US)",
  "Uruguay (UY)",
  "Uzbekistan Sum (UZ)",
  "Vaticano (VA)",
  "San Vicente (VC)",
  "Venezuela (VE)",
  "Islas Vírgenes (VG)",
  "Vietnam (VN)",
  "Vanuatu (VU)",
  "Wallis y Futuna (WF)",
  "Samoa del oeste (WS)",
  "Yemen (YE)",
  "Mayotte (YT)",
  "Serbia (RS)",
  "South Africa (ZA)",
  "Zambia (ZM)",
  "Zimbabwe (ZW)",
  "Puerto Rico (PR)",
  "SAN PABLO (SP)",
  "Argentina (AR)",
  "Aruba (AW)",
  "Curazao (CW)"
];
